// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1cuh7","large":"styles_large__lWVzY"};